import SZAMainImage from '../CardContent/SZAPortal/SZAMAin.png';
import GeneRisk from '../CardContent/SZAPortal/GeneRisk.png';
import NewGenome from '../CardContent/SZAPortal/NewGenome.png';
import OncoRisk from '../CardContent/SZAPortal/OncoRisk.png';
import NewGenome1 from '../CardContent/SZAPortal/NewGenome1.png';
import Image1 from '../CardContent/SZAPortal/1.png';
import Image2 from '../CardContent/SZAPortal/2.png';
import Image3 from '../CardContent/SZAPortal/3.png';
import Image4 from '../CardContent/SZAPortal/4.png';
import Image5 from '../CardContent/SZAPortal/5.png';
import Image6 from '../CardContent/SZAPortal/6.png';
import Image7 from '../CardContent/SZAPortal/Xomicse.png';
import Image8 from '../CardContent/SZAPortal/Varx.png';
import Image9 from '../CardContent/SZAPortal/newb.png';
import Image10 from '../CardContent/SZAPortal/cra.png';
import Image11 from '../CardContent/SZAPortal/oncr.png';
import Image12 from '../CardContent/SZAPortal/oncr1.png';
import Image13 from '../CardContent/SZAPortal/netw.png';
import Image14 from '../CardContent/SZAPortal/rept.png';
import Image15 from '../CardContent/SZAPortal/maf.png';
import Image16 from '../CardContent/SZAPortal/ev.png';
import Image17 from '../CardContent/SZAPortal/gene.png';
import Image18 from '../CardContent/SZAPortal/neg.png';
import Image19 from '../CardContent/SZAPortal/mn.png';
import Image20 from '../CardContent/SZAPortal/varxomics.png';
import HealthImage from '../CardContent/SZAPortal/Health.png';
import OmicsImage from '../CardContent/SZAPortal/Omics.png';
import AIImage from '../CardContent/SZAPortal/AI.png';
import GVEPMain from '../CardContent/SZAPortal/gvep_screen.png';
import GVEPScreen from '../CardContent/SZAPortal/gvep_screen.png';
import GVEPApi from '../CardContent/SZAPortal/gevep_api.png';
import GVEPPage from '../CardContent/SZAPortal/gvep_page.png';
import GVEPM from '../CardContent/SZAPortal/gvep_m.png';

export const platformData = {
  xomics: {
    platformName: "XOmics Portal",
    subtitle: "Comprehensive Multi-Omics Platform",
    headerImage: Image7,
    overview: [
      "XOmics Portal is a comprehensive platform for end-to-end project and infrastructure management, sample processing and tracking, automated report delivery, and integration of multi-agent AI systems.",
      "Designed for seamless in-house integrations of all services. From data handling, analysis and omics discovery to intelligent report delivery."
    ],
    
    // Dynamic content sections
    contentSections: [
      {
        type: "side-by-side",
        title: "Platform Overview",
        image: SZAMainImage,
        content: "The central hub for all omics operations, providing seamless integration across all research workflows and clinical applications."
      },
      {
        type: "features-grid",
        title: "Core Capabilities",
        items: [
          {
            title: "Project Management",
            description: "Comprehensive project management with intelligent automation of infrastructure workflows and real-time decision support.",
            image: SZAMainImage,
            icon: "🔧"
          },
          {
            title: "Patient Observation",
            description: "Real-time patient tracking and observation tools designed to streamline monitoring, data collection, and clinical insights.",
            image: Image2,
            icon: "👁️"
          },
          {
            title: "Cloud Pipeline Processing",
            description: "Automated pipelines that manage data processing, result sorting, and patient communication through a seamless cloud system.",
            image: Image6,
            icon: "👥"
          },
          {
            title: "Sample Handling",
            description: "Secure and efficient in-house sample intake, processing, and tracking designed to ensure full control and traceability.",
            image: Image3,
            icon: "🧪"
          },
          {
            title: "Report Generation",
            description: "Automated reporting pipeline with centralized control, supporting multilingual output and seamless distribution.",
            image: Image4,
            icon: "📊"
          },
          {
            title: "Phenome Atlas",
            description: "A multi-agent system that generates specialized agents for in-house multi-omics analysis, identifies novel discoveries in real time using clinical data.",
            image: Image5,
            icon: "🤖"
          }
        ]
      },
      {
        type: "stats-showcase",
        title: "Platform Impact",
        stats: [
          { label: "Active Projects", value: "250+", icon: "📈" },
          { label: "Samples Processed", value: "10,000+", icon: "🔬" },
          { label: "Reports Generated", value: "5,000+", icon: "📄" },
          { label: "AI Discoveries", value: "150+", icon: "🔍" }
        ]
      }
    ],
    
    benefits: [
      "Streamlined workflow management from sample intake to report delivery",
      "Real-time AI-powered insights and discoveries",
      "Comprehensive patient and cohort management tools",
      "Secure and traceable sample processing",
      "Automated multilingual reporting",
      "Cloud-based pipeline processing with intelligent automation"
    ],
    ctaText: "Access Platform",
    ctaLink: "/dashboard"
  },
  
  generisk: {
    platformName: "GenRiskPro",
    subtitle: "Versatile Platform for Genomic Analysis",
    headerImage: GeneRisk,
    overview: [
      "GenRiskPro is a versatile platform for genomic analysis and report generation, offering a streamlined solution for processing genomic data, conducting in-depth analyses, and producing structured, high-quality reports with ease."
    ],
    
    contentSections: [
      {
        type: "side-by-side",
        title: "Advanced Genomic Analysis",
        image: Image8,
        content: "A unified system for navigating large-scale genomic datasets, performing query-driven analysis, and generating detailed, structured reports efficiently. Built for researchers who need powerful tools with intuitive interfaces."
      },
      {
        type: "workflow-steps",
        title: "Analysis Workflow",
        steps: [
          {
            step: "01",
            title: "Data Input",
            description: "Upload and validate genomic data from multiple sources with automated quality checks.",
            icon: "📁"
          },
          {
            step: "02", 
            title: "Variant Processing",
            description: "Advanced algorithms process and analyze genomic variants with high accuracy and efficiency.",
            icon: "⚡"
          },
          {
            step: "03",
            title: "Analysis & Insights",
            description: "Query-driven analysis provides real-time insights and variant interpretation.",
            icon: "🔍"
          },
          {
            step: "04",
            title: "Report Generation",
            description: "Automated generation of detailed, structured reports with clinical relevance.",
            icon: "📊"
          }
        ]
      },
      {
        type: "tech-specs",
        title: "Technical Specifications",
        specs: [
          { label: "Supported Formats", value: "VCF, FASTQ, BAM, CRAM" },
          { label: "Analysis Speed", value: "< 30 minutes" },
          { label: "Database Size", value: "50+ TB" },
          { label: "Concurrent Users", value: "100+" }
        ]
      }
    ],
    
    benefits: [
      "Streamlined genomic data processing and analysis",
      "Real-time variant interpretation and reporting",
      "Scalable analysis of large genomic datasets",
      "Clinical-grade reporting with actionable insights",
      "Flexible query-based exploration tools",
      "Automated workflow management"
    ],
    ctaText: "Explore Platform",
    ctaLink: "/genriskpro"
  },
  
  familyrisk: {
    platformName: "FamilyRisk",
    subtitle: "Family-Based Variant Analysis for Newborn Screening",
    headerImage: NewGenome,
    overview: [
      "FamilyRisk is a comprehensive platform for newborn sequencing analysis, supporting VCF and PED file inputs with quality control, variant filtration, gene-disease list selection, and multi-mode analysis.",
      "Analyze variants at individual, family, and cohort levels with comparative analysis against major NBSeq projects including BabySeq, BeginNGS, Early Check, Baby Detect, and GUARDIAN."
    ],

    contentSections: [
      {
        type: "side-by-side",
        title: "Multi-Mode Variant Analysis",
        image: Image9,
        content: "Process newborn genomic data through individual-based, family-based, cohort-based, and comparative analysis modes. Generate digital reports with customized comments and publication-ready visualizations.",
        alignment: "left"
      },
      {
        type: "features-grid",
        title: "Analysis Modes",
        items: [
          {
            title: "Individual-Based",
            description: "Support for CNVs and SVs with digital reports containing selected variants, customized comments, and clinical suggestions.",
            image: Image9,
            icon: "👤"
          },
          {
            title: "Family-Based",
            description: "Identification of recessive, de novo, and compound heterozygous variants with pedigree plot visualization.",
            image: Image9,
            icon: "👨‍👩‍👧"
          },
          {
            title: "Cohort-Based",
            description: "Identification of cohort-level common variants with publication-ready visualizations for research studies.",
            image: Image9,
            icon: "👥"
          },
          {
            title: "Comparative Analysis",
            description: "Compare screen-positive results with other NBSeq projects: Early Check, BabySeq, BeginNGS, Baby Detect, and GUARDIAN.",
            image: Image9,
            icon: "📊"
          }
        ]
      }
    ],

    benefits: [
      "Multi-mode analysis: individual, family, cohort, and comparative",
      "Identification of recessive, de novo, and compound heterozygous variants",
      "Pedigree visualization for family-based analysis",
      "Comparison with major NBSeq projects (BabySeq, BeginNGS, GUARDIAN)",
      "Support for CNVs and SVs in individual analysis",
      "Publication-ready visualizations and digital reports"
    ],
    ctaText: "Explore Platform",
    ctaLink: "/familyrisk"
  },
  
  oncorisk: {
    platformName: "OncoRisk",
    subtitle: "Comprehensive Oncology Platform",
    headerImage: OncoRisk,
    overview: [
      "OncoRisk provides comprehensive oncology platform for data exploration, analysis, and reporting. Access one of the largest oncology databases combined with advanced research tools, AI-assisted exploration, and automated report generation—all in a unified system."
    ],
    
    contentSections: [
      {
        type: "side-by-side",
        title: "Oncology Database Access",
        image: Image11,
        content: "Built for oncology research and clinical practice, offering powerful tools for cancer genomics analysis, patient stratification, and personalized treatment planning with access to comprehensive cancer databases.",
        alignment: "left"
      },

      {
        type: "features-grid",
        title: "Core Capabilities",
        items: [
          {
            title: "Database Exploration",
            description: "Unified access to curated oncology databases, integrating mutation profiles, biomarkers, and clinical annotations for streamlined research.",
            image: Image12,
            icon: "🔧"
          },
          {
            title: "Network Analysis",
            description: "Interactive visualization of molecular interaction networks, signaling pathways, and mutation co-occurrence patterns in cancer.",
            image: Image13,
            icon: "👁️"
          },
          {
            title: "Report Generation",
            description: "Automatic generation of clinical-grade oncology reports summarizing variant significance, treatment options, and trial eligibility.",
            image: Image14,
            icon: "👥"
          },
          {
            title: "Deep Query",
            description: "Flexible, real-time querying across patient omics data, allowing researchers to extract clinically relevant insights instantly.",
            image: Image10,
            icon: "🧪"
          },
          {
            title: "Cohort-Level Mutation Analysis",
            description: "Leverages MAF-Tools to uncover patterns across patient cohorts, identifying significantly mutated genes, mutational signatures, and cancer driver events.",
            image: Image15,
            icon: "🤖"
          },
          
          {
            title: "Evidence Exploration",
            description: "Fast cross-referencing of literature, databases, and case studies to support evidence-based treatment planning in oncology.",
            image: Image16,
            icon: "📊"
          },
    
          
        ]
      },
    ],
    
    benefits: [
      "Access to comprehensive oncology databases",
      "AI-powered insights for cancer research",
      "Real-time analysis and reporting capabilities",
      "Personalized treatment recommendations",
      "Advanced patient stratification tools",
      "Integrated clinical decision support for oncology"
    ],
    ctaText: "Access Platform",
    ctaLink: "/oncorisk"
  },
  
  varxomics: {
    platformName: "VarXOmics",
    subtitle: "VCF & Query-Based Genomics Platform",
    headerImage: NewGenome1,
    overview: [
      "VarXOmics is a VCF & query-based genomics platform for exploration and reporting. Explore and visualize genomic data from large databases with query-driven workflows and generate detailed reports—all in one system."
    ],
    
    contentSections: [
      {
        type: "side-by-side",
        title: "Advanced VCF Processing",
        image: Image20,
        content: "Comprehensive genomics platform offering exploration, visualization, and reporting capabilities with advanced query-based workflows for genomic data analysis. Process large-scale VCF files with ease and generate actionable insights."
      },
      {
        type: "features-grid",
        title: "Core Capabilities",
        items: [
          {
            title: "Multi Input Types",
            description: "Support for diverse genomic data inputs including VCF, search terms, and tabular formats—seamlessly integrated for exploratory analysis and downstream workflows.",
            image: Image17,
            icon: "🔧"
          },
          {
            title: "Single Network Analysis",
            description: "Dynamic visualization of variant-driven interaction networks and signaling cascades—ideal for identifying key mutation effects in individual cohorts.",
            image: Image18,
            icon: "👁️"
          },
          {
            title: "Multi Network Analysis",
            description: "Cross comparison of mutational networks, enabling meta-pattern discovery and cohort stratification at scale.",
            image: Image19,
            icon: "👥"
          }
          
     
    
          
        ]
      },
    ],
    
    benefits: [
      "Comprehensive VCF data analysis capabilities",
      "Query-based exploration of genomic datasets",
      "Advanced visualization and reporting tools",
      "Integration with large genomic databases",
      "Flexible workflow management",
      "Clinical-grade genomic reporting"
    ],
    ctaText: "Explore Platform",
    ctaLink: "/varxomics"
  },

  gvep: {
    platformName: "G-VEP",
    subtitle: "GPU-Accelerated Variant Effect Predictor",
    headerImage: GVEPMain,
    overview: [
      "G-VEP is a GPU-accelerated annotation framework that transforms variant annotation from a computational bottleneck into a rapid, parallelized process. Built on a custom CUDA kernel, it replaces sequential per-variant database lookups with massively parallel binary search across precomputed indices.",
      "Reduces plugin runtime from 72 minutes to 4 minutes (17-fold acceleration) and total annotation runtime from 100 minutes to 33 minutes (3-fold acceleration), while maintaining complete concordance with standard VEP output."
    ],

    contentSections: [
      {
        type: "side-by-side",
        title: "Same-Day Whole-Genome Interpretation",
        image: GVEPPage,
        content: "While GPU suites like NVIDIA Parabricks accelerate alignment and variant calling, they don't provide the Ensembl VEP plugin ecosystem used in clinical interpretation. G-VEP removes this final bottleneck and enables same-day whole-genome interpretation."
      },
      {
        type: "features-grid",
        title: "Core Capabilities",
        items: [
          {
            title: "CUDA-Powered Acceleration",
            description: "Custom CUDA kernel executes annotation lookups for all input variants simultaneously using massively parallel binary search.",
            image: GVEPMain,
            icon: "⚡"
          },
          {
            title: "Clinical Validation",
            description: "Benchmarked across clinical whole-genome samples with zero annotation discrepancies. All clinically significant findings preserved.",
            image: GVEPM,
            icon: "✓"
          },
          {
            title: "Multiple Access Methods",
            description: "Available as command-line tool, web server, and REST API. 8.8 GB index footprint fits within consumer-grade 16 GB GPUs.",
            image: GVEPApi,
            icon: "🔧"
          }
        ]
      },
      {
        type: "stats-showcase",
        title: "Performance Metrics",
        stats: [
          { label: "Plugin Speedup", value: "17x", icon: "🚀" },
          { label: "Total Speedup", value: "3x", icon: "⚡" },
          { label: "Index Size", value: "8.8 GB", icon: "💾" },
          { label: "Accuracy", value: "100%", icon: "✓" }
        ]
      }
    ],

    benefits: [
      "17-fold acceleration of VEP annotation plugins",
      "Complete concordance with standard VEP output",
      "Validated on cohorts clinical whole-genome samples",
      "Fits in consumer-grade 16 GB GPUs",
      "Available as CLI, web server, and REST API",
      "Enables same-day whole-genome interpretation"
    ],
    ctaText: "Try G-VEP",
    ctaLink: "/gvep"
  },

  mobileapp: {
    platformName: "XOmics Mobile",
    subtitle: "Your Personal Health & Omics Companion",
    headerImage: AIImage,
    overview: [
      "Bridging the gap between complex genomic data and personal health, XOmics Mobile places powerful insights directly into your hands. Our application provides a secure, intuitive interface to explore your unique biological data, track health metrics, and interact with an AI-driven health assistant.",
      "Receive simplified clinical reports, understand your genetic predispositions, and get personalized recommendations, all from the privacy of your phone. It's not just data; it's your health story, decoded."
    ],
    
    contentSections: [
      {
        type: "features-grid",
        title: "A New Era of Personal Health",
        items: [
          {
            title: "Interactive Omics Dashboard",
            description: "Visualize your genomic, proteomic, and metabolomic data through beautiful, easy-to-understand charts and interactive models. Discover what your omics say about you.",
            image: OmicsImage,
          },
          {
            title: "AI-Powered Health Assistant",
            description: "Have a question? Our advanced AI is trained on your health data to provide personalized answers, explain complex topics, and guide you on your wellness journey.",
            image: AIImage,
          },
          {
            title: "Holistic Health Tracking",
            description: "Integrate data from wearables and clinical records. Track your lifestyle, symptoms, and biomarkers to see the full picture of your health and the impact of your choices.",
            image: HealthImage,
          }
        ]
      }
    ],
    
    benefits: [
      "Empowers patients with direct access to their omics data",
      "Delivers personalized, AI-driven health recommendations",
      "Simplifies complex clinical reports into actionable insights",
      "Provides a secure platform for health data management",
      "Encourages proactive health monitoring and lifestyle adjustments",
      "Facilitates better communication with healthcare providers"
    ],
    ctaText: "Download App Now",
    ctaLink: "https://apps.apple.com/se/app/sza-longevity/id6468774325"
  }
}; 